import { useState } from "react";
import { buzzList } from "@/mocks/home";

export default function BuzzSection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="buzz" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="reveal max-w-3xl">
          <span className="text-xs font-label font-medium tracking-widest text-secondary-700">
            NETIZEN TALK
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-black text-foreground-950">
            网友热议 · 评论区也很精彩
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            挑选出讨论度高、信息量足的网友观点，帮你从不同角度看同一件事。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {buzzList.map((item) => (
            <figure
              key={item.id}
              className="reveal flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 transition-colors hover:border-secondary-300"
            >
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.nick}的头像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <figcaption className="text-sm font-medium text-foreground-950 truncate">
                    {item.nick}
                  </figcaption>
                  <p className="text-xs text-secondary-700 truncate">热议 · {item.topic}</p>
                </div>
              </div>

              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">
                「{item.text}」
              </blockquote>

              <div className="mt-auto pt-5 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-500">
                  <i className="ri-chat-3-line" aria-hidden="true" />
                  热评精选
                </span>
                <button
                  type="button"
                  onClick={() => toggleLike(item.id)}
                  aria-pressed={!!liked[item.id]}
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-label whitespace-nowrap cursor-pointer transition-colors ${
                    liked[item.id]
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  <i
                    className={liked[item.id] ? "ri-heart-3-fill" : "ri-heart-3-line"}
                    aria-hidden="true"
                  />
                  {(item.likes + (liked[item.id] ? 1 : 0)).toLocaleString()}
                </button>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}